<div class="container">
  <div class="image-description">
    <div class="image-circular">
      <img class="image-offer" [src]="campaign.product_image_url ? campaign.product_image_url : '../../../assets/svgs/image_default.svg'" [ngClass]="{'nimg': campaign.product_image_url === undefined }" alt="Lead Oferecido">
    </div>
    <div class="descriptions">
      <p class="information" *ngIf="campaign.name"><span class="title">Campanha:</span>{{ campaign.name }}</p>
      <p class="information" *ngIf="campaign.product_name">
        <span class="title">Produto:</span>
        <ng-container *ngIf="campaign.product_alias">{{ campaign.product_alias }}</ng-container>
        <ng-container *ngIf="!campaign.product_alias">{{ campaign.product_name }}</ng-container>
        -
        <a class="link" *ngIf="campaign.product_sku" target="_blank" href="/produtos/ficha/{{campaign.product_sku}}">Ficha do imóvel</a>
      </p>
      <p class="information" *ngIf="campaign.subscription">
        <span class="title">Inscrição:</span>
        de {{ campaign.subscription.start | date:'dd/MM/yy' }} à {{ campaign.subscription.end | date:'dd/MM/yy' }} - {{ campaign.subscription.description }}
      </p>
      <p class="information" *ngIf="campaign.duration.start && campaign.duration.end">
        <span class="title">Vigência:</span>
        de {{ campaign.duration.start | date:'dd/MM/yy' }} à {{ campaign.duration.end | date:'dd/MM/yy' }} - {{ campaign.duration.description }}
      </p>
    </div>
  </div>
  <mat-spinner *ngIf="isLoading" [diameter]="24" color="warn"></mat-spinner>
  <button *ngIf="!isLoading"
  class="btn" 
  id="action-lead"
  [ngClass]="{
    'disabled': campaign.participating && !isEditable
  }"
  [disabled]="campaign.participating && !isEditable"
  (click)="associate()">
    {{ getBttnName() }}
  </button>
</div>